import { format } from 'date-fns';
import { Text } from '~/commonComponents';
import EditPencilIcon from '~/images/icons/EditPencil';
import { Colors } from '~/themes/colors';

interface IEditableDatePillProps {
  date: Date;
  onClick: () => void;
}

export const EditableDatePill = ({ date, onClick }: IEditableDatePillProps) => (
  <button
    type="button"
    data-testid="editable-date-pill"
    data-cy="editable-date-pill"
    onClick={onClick}
    style={{
      all: 'unset',
      display: 'inline-flex',
      alignItems: 'center',
      gap: 8,
      padding: '8px 16px',
      borderRadius: 24,
      border: `1.5px solid ${Colors.secondary_500}`,
      backgroundColor: Colors.secondary_25,
      cursor: 'pointer',
    }}
  >
    <Text fontSize={16} color="neutral_600">
      {format(date, 'EEE, MMM dd, yyyy')}
    </Text>
    <EditPencilIcon size={16} color={Colors.secondary_500} />
  </button>
);
